import {useEffect, useState} from 'react';

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token ? {'Authorization': `Bearer ${token}`} : {};
}

/**
 * Fetch alerts for an entity.
 * Phase 6 replacement for Firestore `alerts` collection query.
 */
export function useEntityAlerts(entityId) {
    const [alerts, setAlerts] = useState([]);
    const [loading, setLoading] = useState(!!entityId);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!entityId) { setAlerts([]); setLoading(false); setError(null); return; }

        let cancelled = false;
        setLoading(true); setError(null);

        fetch(
            `${BASE}/api/documents/alerts?entityId=${encodeURIComponent(entityId)}`,
            {headers: authHeaders()}
        )
            .then((r) => r.ok ? r.json() : [])
            .then((data) => { if (!cancelled) { setAlerts(Array.isArray(data) ? data : []); setLoading(false); } })
            .catch((err) => { if (!cancelled) { setError(err); setLoading(false); } });

        return () => { cancelled = true; };
    }, [entityId]);

    return {alerts, loading, error};
}
